import { render, staticRenderFns } from "./sectionLook.vue?vue&type=template&id=590b8490&scoped=true&"
import script from "./sectionLook.vue?vue&type=script&lang=js&"
export * from "./sectionLook.vue?vue&type=script&lang=js&"
import style0 from "./sectionLook.vue?vue&type=style&index=0&id=590b8490&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590b8490",
  null
  
)

export default component.exports